// extracted by mini-css-extract-plugin
module.exports = {"text":"cta_text__d7VD4"};